import { cn } from "@/lib/utils";

// Full official ADMINIA logo (never cropped, white background preserved).
export function Logo({ className, size = 44 }) {
  return (
    <img
      src="/adminia-logo.jpeg"
      alt="ADMINIA — vos démarches simplifiées"
      data-testid="adminia-logo"
      style={{ height: size, width: size }}
      className={cn("object-contain rounded-md bg-white", className)}
    />
  );
}

export function LogoWordmark({ className }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="logo-wordmark">
      <Logo size={40} />
      <span className="font-heading font-extrabold text-xl tracking-tight text-brand">
        adminia
      </span>
    </div>
  );
}
